
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91quality_9317BpklGZjIMeta } from "/home/manohar/dev/mall-nuxt/pages/[offersType]/[quality].vue?macro=true";
import { default as _91pid_93slTymSH3W5Meta } from "/home/manohar/dev/mall-nuxt/pages/[slug]/p/[pid].vue?macro=true";
import { default as aboutClFDIOP6wvMeta } from "/home/manohar/dev/mall-nuxt/pages/about.vue?macro=true";
import { default as account_45deletionIXiMFPVjRfMeta } from "/home/manohar/dev/mall-nuxt/pages/account-deletion.vue?macro=true";
import { default as addressnB2bgkJf6zMeta } from "/home/manohar/dev/mall-nuxt/pages/address.vue?macro=true";
import { default as cartCfKa3JwVvyMeta } from "/home/manohar/dev/mall-nuxt/pages/cart.vue?macro=true";
import { default as checkoutNqDLS4tTPWMeta } from "/home/manohar/dev/mall-nuxt/pages/checkout.vue?macro=true";
import { default as contactPULSkIdE5rMeta } from "/home/manohar/dev/mall-nuxt/pages/contact.vue?macro=true";
import { default as couponsuixERv6X8XMeta } from "/home/manohar/dev/mall-nuxt/pages/coupons.vue?macro=true";
import { default as faqWe0OKhbgqdMeta } from "/home/manohar/dev/mall-nuxt/pages/faq.vue?macro=true";
import { default as indexuaStQ6IMe0Meta } from "/home/manohar/dev/mall-nuxt/pages/index.vue?macro=true";
import { default as loginFCab73ayh8Meta } from "/home/manohar/dev/mall-nuxt/pages/login.vue?macro=true";
import { default as notificationskaa0OoXfwbMeta } from "/home/manohar/dev/mall-nuxt/pages/notifications.vue?macro=true";
import { default as cancel0BdDDLi1VrMeta } from "/home/manohar/dev/mall-nuxt/pages/orders/[id]/cancel.vue?macro=true";
import { default as index8FqonvokKbMeta } from "/home/manohar/dev/mall-nuxt/pages/orders/[id]/index.vue?macro=true";
import { default as returnelMUicgEbnMeta } from "/home/manohar/dev/mall-nuxt/pages/orders/[id]/return.vue?macro=true";
import { default as indexGalmptRrIvMeta } from "/home/manohar/dev/mall-nuxt/pages/orders/index.vue?macro=true";
import { default as successwXksF1iWbwMeta } from "/home/manohar/dev/mall-nuxt/pages/orders/success.vue?macro=true";
import { default as payments9ezXtMESdUMeta } from "/home/manohar/dev/mall-nuxt/pages/payments.vue?macro=true";
import { default as privacyGlsNX3K2rEMeta } from "/home/manohar/dev/mall-nuxt/pages/privacy.vue?macro=true";
import { default as productsroC5hZdmzIMeta } from "/home/manohar/dev/mall-nuxt/pages/products.vue?macro=true";
import { default as profileI9ecLzeKSMMeta } from "/home/manohar/dev/mall-nuxt/pages/profile.vue?macro=true";
import { default as ratings_45reviewsh9bL2xgZ40Meta } from "/home/manohar/dev/mall-nuxt/pages/ratings-reviews.vue?macro=true";
import { default as return_45policyrbEjQAnKJmMeta } from "/home/manohar/dev/mall-nuxt/pages/return-policy.vue?macro=true";
import { default as terms_45and_45conditionskycQG6P3rzMeta } from "/home/manohar/dev/mall-nuxt/pages/terms-and-conditions.vue?macro=true";
import { default as wishlistkcpDTTEoDgMeta } from "/home/manohar/dev/mall-nuxt/pages/wishlist.vue?macro=true";
export default [
  {
    name: "offersType-quality",
    path: "/:offersType()/:quality()",
    component: () => import("/home/manohar/dev/mall-nuxt/pages/[offersType]/[quality].vue")
  },
  {
    name: "slug-p-pid",
    path: "/:slug()/p/:pid()",
    component: () => import("/home/manohar/dev/mall-nuxt/pages/[slug]/p/[pid].vue")
  },
  {
    name: "about",
    path: "/about",
    meta: aboutClFDIOP6wvMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/about.vue")
  },
  {
    name: "account-deletion",
    path: "/account-deletion",
    component: () => import("/home/manohar/dev/mall-nuxt/pages/account-deletion.vue")
  },
  {
    name: "address",
    path: "/address",
    meta: addressnB2bgkJf6zMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/address.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/home/manohar/dev/mall-nuxt/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkoutNqDLS4tTPWMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/checkout.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/manohar/dev/mall-nuxt/pages/contact.vue")
  },
  {
    name: "coupons",
    path: "/coupons",
    meta: couponsuixERv6X8XMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/coupons.vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: faqWe0OKhbgqdMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/faq.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/manohar/dev/mall-nuxt/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginFCab73ayh8Meta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/login.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationskaa0OoXfwbMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/notifications.vue")
  },
  {
    name: "orders-id-cancel",
    path: "/orders/:id()/cancel",
    component: () => import("/home/manohar/dev/mall-nuxt/pages/orders/[id]/cancel.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    meta: index8FqonvokKbMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/orders/[id]/index.vue")
  },
  {
    name: "orders-id-return",
    path: "/orders/:id()/return",
    component: () => import("/home/manohar/dev/mall-nuxt/pages/orders/[id]/return.vue")
  },
  {
    name: "orders",
    path: "/orders",
    meta: indexGalmptRrIvMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/orders/index.vue")
  },
  {
    name: "orders-success",
    path: "/orders/success",
    meta: successwXksF1iWbwMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/orders/success.vue")
  },
  {
    name: "payments",
    path: "/payments",
    meta: payments9ezXtMESdUMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/payments.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyGlsNX3K2rEMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/privacy.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/home/manohar/dev/mall-nuxt/pages/products.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profileI9ecLzeKSMMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/profile.vue")
  },
  {
    name: "ratings-reviews",
    path: "/ratings-reviews",
    meta: ratings_45reviewsh9bL2xgZ40Meta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/ratings-reviews.vue")
  },
  {
    name: "return-policy",
    path: "/return-policy",
    meta: return_45policyrbEjQAnKJmMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/return-policy.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    meta: terms_45and_45conditionskycQG6P3rzMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/terms-and-conditions.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    meta: wishlistkcpDTTEoDgMeta || {},
    component: () => import("/home/manohar/dev/mall-nuxt/pages/wishlist.vue")
  }
]